export const TOOLTIP_OPEN_DELAY = 500;
